import React from 'react';

import { useSelector } from 'react-redux';

import StaticField from 'components/StaticField';
import { CUSTOMER_LAST_NAME } from 'modules/Inquiry/Form/formFields';
import { getCustomerData } from 'store/inquiryDetails/selectors';
import { useTranslations } from 'utils/hooks/useTranslations';

const LastNameStaticField = () => {
  const customerData = useSelector(getCustomerData);
  const t = useTranslations('pages.customerData.sections.contactPerson.fields.lastName');
  return <StaticField caption={t('caption')} text={customerData[CUSTOMER_LAST_NAME]} />;
};

export default LastNameStaticField;
